import { CONTENT } from "@malirang/common";
import { IMenu } from "../../../stores/layout.store";

export const menus: IMenu[] = [
    {
        name: "회원 관리",
        icon: "material-symbols:person",
        href: "user",
    },
    {
        name: "센터 관리",
        icon: "material-symbols:business-center",
        href: "center",
    },
    {
        name: "발달센터 찾기 관리",
        icon: "material-symbols:business-center",
        href: "growth",
    },
    {
        name: "아동 관리",
        icon: "fa6-solid:child-reaching",
        href: "child",
    },
    {
        name: "서비스 관리",
        icon: "material-symbols:folder-copy-rounded",
        children: [
            { href: "voucher", name: "바우처 관리" },
            { href: "ticket-type", name: "치료유형 관리" },
            { href: "document", name: "치료문서 관리" },
            {
                href: "inspection-data-category",
                name: "검사 자료 카테고리 관리",
            },
        ],
    },
    {
        name: `${CONTENT} 관리`,
        icon: "tabler:file-text",
        children: [
            { href: "content-category", name: "카테고리 관리" },
            { href: "content", name: `${CONTENT} 관리` },
        ],
    },
    {
        name: "선생님 고객지원 관리",
        icon: "hugeicons:teacher",
        children: [
            {
                href: `/teacher/notice`,
                name: "선생님 공지사항",
                icon: "tabler:article",
            },
            {
                href: `/teacher/faq`,
                name: "선생님 FAQ",
                icon: "tabler:help-circle-filled",
            },
            {
                href: `/teacher/inquiry`,
                name: "선생님 1:1 문의",
                icon: "tabler:message-question",
            },
        ],
    },
    {
        name: "부모님 고객지원 관리",
        icon: "tabler:message-question",
        children: [
            {
                href: `/parent/notice`,
                name: "부모님 공지사항",
                icon: "tabler:article",
            },
            {
                href: `/parent/faq`,
                name: "부모님 FAQ",
                icon: "tabler:help-circle-filled",
            },
            {
                href: `/parent/inquiry`,
                name: "부모님 1:1 문의",
                icon: "tabler:message-question",
            },
        ],
    },
    {
        name: "결제 관리",
        icon: "ic:outline-payments",
        href: "payment",
    },
    {
        name: "설정",
        icon: "tabler:device-mobile",
        children: [
            { href: "company-info", name: "회사 정보 관리" },
            { href: "term", name: "약관 관리" },
        ],
    },
    {
        name: "관리자 관리",
        icon: "material-symbols:admin-panel-settings",
        href: "admin",
    },
    {
        name: "팝업 관리",
        icon: "carbon:popup",
        href: "popup",
    },
    {
        name: "푸시 알림 관리",
        icon: "material-symbols:ads-click",
        href: "ad",
    },
    {
        name: "LP 검사 관리",
        icon: "bx:test-tube",
        href: "inspection",
    },
    {
        name: "쿠폰 관리",
        icon: "lsicon:coupon-outline",
        children: [
            { href: "/coupon/member-coupon", name: "회원 쿠폰" },
            { href: "/coupon/auto-issued-coupon", name: "자동발행 쿠폰" },
            { href: "/coupon/coupon-usage-history", name: "쿠폰사용 내역" },
            { href: "/coupon", name: "비회원(LP조음검사)" },
        ],
    },
];
